<template>
  <el-dialog
    :title="lotteryInfo.lotteryId ? '编辑单品抽奖' : '新增单品抽奖'"
    :visible.sync="visible"
    width="700px"
    :close-on-press-escape="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      v-loading="loading"
      :model="lotteryInfo"
      :rules="rules"
      label-width="90px">
      <el-form-item
        label="活动名称:"
        prop="lotteryName">
        <el-input v-model="lotteryInfo.lotteryName"></el-input>
      </el-form-item>
      <el-form-item
        label="活动描述:"
        prop="lotteryRule">
        <el-input v-model="lotteryInfo.lotteryRule"></el-input>
      </el-form-item>
      <el-form-item
        label="商品:"
        prop="prizes">
        <el-button
          type="primary"
          @click="selectGoods">选择商品</el-button>
        <el-table
          v-if="lotteryInfo.prizes.length"
          style="margin-top:10px"
          border
          :data="lotteryInfo.prizes">
          <el-table-column
            label="商品名称"
            prop="goodsName"></el-table-column>
          <el-table-column
            label="库存量"
            width="90"
            prop="storageCount"></el-table-column>
          <el-table-column label="奖品数量">
            <template slot-scope="{row}">
              <el-input-number
                v-model="row.count"
                :min="1"
                :max="row.storageCount"
                @change="handleCountChange"></el-input-number>
              <!-- <el-form-item label=""
                :prop="`prizes.${$index}.count`"
                :rules="{ required: true, message: '请输入奖品数量', trigger: 'blur' }">
                <el-input-number @change="handleCountChange"
                  v-model="row.count"
                  :min="1"
                  :max="row.storageCount"></el-input-number>
              </el-form-item> -->
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item
        label="抽奖积分:"
        prop="points">
        <el-input-number
          v-model="lotteryInfo.points"
          :disabled="!lotteryInfo.prizes.length"
          :min="1"></el-input-number>
      </el-form-item>
      <el-form-item
        label="抽奖次数:"
        prop="count">
        <el-input-number
          v-model="lotteryInfo.count"
          :disabled="!lotteryInfo.prizes.length"
          :min="min"></el-input-number>
      </el-form-item>
      <el-form-item
        v-show="lotteryInfo.status === 1"
        label="结束日期:"
        prop="closeTime">
        <el-date-picker
          v-model="lotteryInfo.closeTime"
          type="date"
          :picker-options="pickerOptions"
          placeholder="选择结束日期">
        </el-date-picker>
        <span style="color: red;font-size:12px"><i class="el-icon-warning"></i>不填表示抽奖人次满后自动结束</span>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-checkbox
        v-model="lotteryInfo.status"
        :true-label="1"
        :false-label="0">立即上线</el-checkbox>
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">提 交</el-button>
    </span>
    <goods-select-modal
      ref="modal"
      :callback="formatSelected" />
  </el-dialog>
</template>

<script>
import GoodsSelectModal from './lottery-goods-select-modal.vue'
import moment from 'moment'
import _ from 'lodash'
export default {
  name: 'LotteryRegisterModal',
  components: { GoodsSelectModal },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      visible: false,
      pickerOptions: {
        disabledDate: (date) => {
          return date < Date.now()
        }
      },
      lotteryInfo: {
        lotteryName: '',
        lotteryRule: '',
        lotteryType: 1,
        points: null,
        count: null,
        status: 0,
        prizes: [],
        closeTime: null
      }
    }
  },
  computed: {
    min() {
      let count = 0
      this.lotteryInfo.prizes.forEach(i => {
        count += (i.count || 0)
      })
      return count
    },
    rules() {
      return {
        prizes: [
          { required: true, message: '请选择商品', trigger: 'change' }
        ],
        lotteryName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        points: [
          { required: true, message: '请输入抽奖积分', trigger: 'blur' }
        ],
        count: [
          { required: true, message: '请输入抽奖次数', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              let count = 0
              this.lotteryInfo.prizes.forEach(i => {
                count += (i.count || 0)
              })
              if (value < count) {
                callback(new Error('抽奖次数必须大于奖品次数'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.lotteryInfo = {
        lotteryName: '',
        lotteryRule: '',
        lotteryType: 1,
        points: null,
        count: null,
        status: 0,
        prizes: [],
        closeTime: null
      }
      this.$refs.ruleForm.clearValidate()
    },
    handleCountChange(val) {
      console.log(val)
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          const dispatch = this.lotteryInfo.lotteryId ? 'updatelottery' : 'addlottery'
          this.$store.dispatch(`lottery/${dispatch}`, {
            payload: {
              ...this.lotteryInfo,
              prizes: this.lotteryInfo.prizes.map(i => {
                return {
                  goodsId: i.goodsId,
                  prizeType: 1,
                  count: i.count
                }
              }),
              startTime: this.lotteryInfo.status === 1 ? +Date.now() : null,
              closeTime: this.lotteryInfo.status === 1 ? (this.lotteryInfo.closeTime ? +moment(this.lotteryInfo.closeTime).endOf('day') : null) : null
            },
            success: () => {
              this.loading = false
              this.callback && this.callback()
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    formatSelected(data) {
      data = _.cloneDeep(data)
      data.count = 1
      data.goodsId = data.exchangeGoodsId
      this.lotteryInfo.prizes.splice(0, 1, data)
      this.$refs.ruleForm.clearValidate('prizes')
    },
    selectGoods() {
      this.$refs.modal.fetch()
    },
    fetch({ vendorId, lotteryId }) {
      if (lotteryId) {
        this.loading = true
        this.$store.dispatch('lottery/getlottery', {
          payload: {
            vendorId, lotteryId
          },
          success: res => {
            this.loading = false
            res.data.prizes.forEach(i => {
              i.storageCount = i.storageCount + i.count
            })
            this.lotteryInfo = {
              ...this.lotteryInfo,
              ...res.data
            }
            this.toggleModal(true)
          },
          fail: () => {
            this.loading = false
          }
        })
      } else {
        this.toggleModal(true)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
